module.exports = __webpack_public_path__ + "static/media/save_work.12588b52.png";